import React from 'react'
import PropTypes from 'prop-types'
import HighlightText from '../components/HighlightText'
import Button from '../elements/Button'
import CustomLink from '../components/CustomLink'
import NbnFeatures from '../nbn/NbnFeatures'
import BackgroundCurves from '../components/BackgroundCurves'
import ExpandableListModule from './ExpandableListModule'
import { useMedia } from 'react-use'
import data from '../../data/nbn/exetel-a-friend.json'

const ExetelAFriend = (props) => {
    const isMobile = useMedia('(max-width: 992px)')

    const Copy = () => {
        return (
            <div className='row'>
                <div className='col-12 col-lg-6'>
                    <h1 className='m-0 mb-4'>Exetel-a-friend and save!</h1>
                    <p className='m-0 mb-2'>Tell your friends about our award-winning nbn™ broadband and save 10% (up to $10) on your broadband plan fee for the next 6 months.</p>
                    <p className='m-0'>You can even stack your discount so the more friends who sign up, the more you save.</p>
                </div>
            </div>
        )
    }

    return (
        <React.Fragment>
            <div className='exetel-a-friend'>
                {isMobile
                    ? <div className='bg'>
                        <img src='/images/exetel-a-friend-mobile.png' alt='Exetel-a-friend' />
                    </div>
                    : ''}
                <div className='inner-container'>
                    {!isMobile
                        ? <React.Fragment>
                            <div className='bg'>
                                <img src='/images/exetel-a-friend-desktop.png' alt='Exetel-a-friend' />
                            </div>
                            <div className='copy'>
                                <div className='inner'>
                                    <Copy />
                                </div>
                            </div>
                        </React.Fragment>
                        : <div className='text-center'>
                            <Copy />
                        </div>}

                    <div className='steps'>
                        <div className='text-center'>
                            <h2 className='m-0 mb-5'>It only takes <HighlightText>3 easy steps</HighlightText> to save</h2>
                        </div>

                        <div className='d-flex flex-column flex-lg-row'>
                            <div className='step'>
                                <h2 className='m-0 mb-lg-3'>1.</h2>
                                <div className='img'>
                                    <img src='/images/exefriend-step1.jpg' alt='Exetel a friend' />
                                </div>
                                <p className='mb-5'>Make sure you’re <span className='bold'>already signed up to an Exetel</span> nbn™ home broadband plan.<br />&nbsp;</p>
                                <div className='text-center'>
                                    <CustomLink to='/broadband/nbn' className='btn btn-custom'>Sign up today</CustomLink>
                                </div>
                            </div>
                            <div className='step'>
                                <h2 className='m-0 mb-lg-3'>2.</h2>
                                <div className='img'>
                                    <img src='/images/exefriend-step3.jpg' alt='Exetel a friend' />
                                </div>
                                <p className='mb-5'>When you’re connected, <span className='bold'>sign in to your My Exetel account</span> and <span className='bold'>find your unique referral code</span> under Useful Tools. <span className='bold'>Share that code</span> with everyone you know!</p>
                                <div className='text-center'>
                                    <Button href='https://my.exetel.com.au/exetel-a-friend' className='btn btn-custom'>Login to My Exetel</Button>
                                </div>
                            </div>
                            <div className='step'>
                                <h2 className='m-0 mb-lg-3'>3.</h2>
                                <div className='img'>
                                    <img src='/images/exefriend-step2.jpg' alt='Exetel a friend' />
                                </div>
                                <p className='mb-0'><span className='bold'>Once your friend signs up</span> for any Exetel nbn™ home broadband plan using your personalised referral code, <span className='bold'>you’ll receive 10% off</span> (up to $10) your broadband plan fee <span className='bold'>for six months</span>. The more people who sign up using your code, the more you save (up to a maximum of 100% off, T&Cs apply).</p>
                            </div>
                        </div>

                        <p className='text-center m-0 mt-4'>
                            See <CustomLink to='https://files.exetel.com.au/terms/Exetel-a-friend_Terms.pdf'>terms & conditions</CustomLink> for more information.
                        </p>
                    </div>
                </div>
            </div>
            <BackgroundCurves color='lightgrey' innerClassName='inner-container pb-5' hideBottomCurve>
                <div id='thingsToKnow' />
                <ExpandableListModule title='Things you need to know' data={data.needToKnow} hasPadding={false} />
            </BackgroundCurves>
        </React.Fragment>
    )
}

ExetelAFriend.propTypes = {}

export default ExetelAFriend



// WEBPACK FOOTER //
// ./resources/js/modules/ExetelAFriend.js